import './schedule-header.scss'
import { FormattedMessage } from 'react-intl'

export const buttons = [
  {
    title: <FormattedMessage id='all' defaultMessage='All' />,
    type: 'all',
    icon: 'icon-check-all',
  },
  {
    title: <FormattedMessage id='diving' defaultMessage='Diving' />,
    type: 'dive-trips',
    icon: 'icon-diver',
  },
  {
    title: <FormattedMessage id='courses' defaultMessage='Courses' />,
    type: 'courses',
    icon: 'icon-course',
  },
  {
    title: <FormattedMessage id='snorkeling' defaultMessage='Snorkeling' />,
    type: 'snorkelling',
    icon: 'icon-snorkeling',
  },
  {
    title: <FormattedMessage id='social' defaultMessage='Social' />,
    type: 'social-events',
    icon: 'icon-champagne',
  },
  {
    title: <FormattedMessage id='conservation' defaultMessage='Conservation' />,
    type: 'conservation',
    icon: 'icon-conservation',
  },
]
export default function ScheduleHeader({ selectedType, onTypeChange }) {
  return (
    <div className='schedule-header'>
      <div className='toggle-buttons'>
        {buttons.map((item) => {
          const onClick = () => onTypeChange(item.type)
          return (
            <button
              id={`schedule-btn-${item.type}`}
              key={item.type}
              className={`btn ${item.type === selectedType && 'active'}`}
              onClick={onClick}
            >
              <i className={`font-icons ${item.icon}`} />
              {item.title}
            </button>
          )
        })}
      </div>
    </div>
  )
}
